import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { configuracion } from 'src/app/recursos/config.service';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { IngresoService } from 'src/app/servicios/ingreso.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';
import { SeleccionService } from 'src/app/servicios/seleccion.service';

@Component({
  selector: 'app-ficha-responde-estudiante',
  templateUrl: './ficha-responde-estudiante.component.html',
  styleUrls: ['./ficha-responde-estudiante.component.css']
})
export class FichaRespondeEstudianteComponent implements OnInit {

  public mr: NgbModalRef;

  public encabezado: string = "";
  public vecVerEncuesta = []; public vecVerGrupos = []; public vecVerPreguntas = []; public vecVerOpciones = []; public vecVerSubOpcion = []; public vecVerRespuesta = [];
  vecPeriodo: Array<any> = []; vecDataCalcula: Array<any> = [];
  datoEnc: string = ''; datoRes: string = ''; public editaRes: boolean = false;

  constructor(private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent, private srvSelect: SeleccionService,
    private srvGeneral: recursosCompartido, private confMensaje: configuracion, private ruta: Router) { }
  ngOnInit() {
    this.encabezado = "Ficha del Estudiante";
    this.verEstadoMatricula();
    this.vecVerEncuesta.push({
      datFecha: '', detEstado: '', detVisible: '', fltTiempo: '', intEstado: '', intIdEncuesta: '', intVisible: '', strCreado: '', strDescripcion: '', strNombre: '',
      strRecomendacion: '', strTerminos: ''
    });
  }

  async verEstadoMatricula() {
    this.cargando.abrir();
    this.vecDataCalcula = [];
    this.vecPeriodo = await this.srvGeneral.verPeriodoVigente();
    //VERIFICAR EL PERIODO VIGENTE A LA FECHA
    if (this.vecPeriodo[0].estado) {
      let vecMatricula = await this.srvGeneral.verDataMatricula('', this.vecPeriodo[0].periodo[0].strCodigo, localStorage.getItem('ciUsuario'))
      let vecCentral = await new Promise<any>(resolve => this.srvSelect.personaCentral2Documento(localStorage.getItem('ciUsuario')).subscribe(translated => { resolve(translated) }));
      let vecColegio = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(8, localStorage.getItem('ciUsuario'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
      if (vecMatricula[0].banMatricula && vecCentral.success) {
        this.vecDataCalcula.push({ numBusca: 1, nombPregunta: 'NOMBRES Y APELLIDOS:', respuesta: vecMatricula[0].matricula[0].nombEstudiante + ' ' + vecMatricula[0].matricula[0].apelEstudiante });
        this.vecDataCalcula.push({ numBusca: 2, nombPregunta: 'APELLIDOS:', respuesta: vecMatricula[0].matricula[0].apelEstudiante });
        this.vecDataCalcula.push({ numBusca: 3, nombPregunta: 'CÉDULA/PASAPORTE:', respuesta: vecMatricula[0].matricula[0].cedEstudiante });
        this.vecDataCalcula.push({ numBusca: 4, nombPregunta: 'CÓDIGO ESTUDIANTIL:', respuesta: vecMatricula[0].matricula[0].codEstudiante });
        this.vecDataCalcula.push({ numBusca: 5, nombPregunta: 'LUGAR DE NACIMIENTO:', respuesta: vecCentral.listado[0].datosprocedencia });
        this.vecDataCalcula.push({ numBusca: 6, nombPregunta: 'PAÍS DE NACIMIENTO:', respuesta: vecCentral.listado[0].nac_nombre });
        this.vecDataCalcula.push({ numBusca: 7, nombPregunta: 'PROVINCIA:', respuesta: vecCentral.listado[0].datosprocedencia.split('/').length > 1 ? vecCentral.listado[0].datosprocedencia.split('/')[0] : '' });
        this.vecDataCalcula.push({ numBusca: 8, nombPregunta: 'CANTÓN:', respuesta: vecCentral.listado[0].datosprocedencia.split('/').length > 2 ? vecCentral.listado[0].datosprocedencia.split('/')[1] : '' });
        this.vecDataCalcula.push({ numBusca: 9, nombPregunta: 'PARROQUIA:', respuesta: vecCentral.listado[0].prq_nombre });
        this.vecDataCalcula.push({ numBusca: 10, nombPregunta: 'FECHA DE NACIMIENTO:', respuesta: vecCentral.listado[0].per_fechaNacimiento.split('T')[0] });
        this.vecDataCalcula.push({ numBusca: 11, nombPregunta: 'SEXO:', respuesta: vecCentral.listado[0].sexo });
        this.vecDataCalcula.push({ numBusca: 12, nombPregunta: 'CORREO ELECTRÓNICO INSTITUCIONAL:', respuesta: vecCentral.listado[0].per_email });
        this.vecDataCalcula.push({ numBusca: 13, nombPregunta: 'CORREO ELECTRÓNICO PERSONAL:', respuesta: vecCentral.listado[0].per_emailAlternativo });
        this.vecDataCalcula.push({ numBusca: 14, nombPregunta: 'ESTADO CIVIL:', respuesta: vecCentral.listado[0].eci_nombre });
        this.vecDataCalcula.push({ numBusca: 15, nombPregunta: 'FACULTAD A LA QUE PERTENECE:', respuesta: vecMatricula[0].matricula[0].nombFacultad });
        this.vecDataCalcula.push({ numBusca: 16, nombPregunta: 'CARRERA A LA QUE PERTENECE:', respuesta: vecMatricula[0].matricula[0].nombCarrera });
        this.vecDataCalcula.push({ numBusca: 17, nombPregunta: 'NIVEL ACTUAL:', respuesta: vecMatricula[0].matricula[0].codNivel });
        this.vecDataCalcula.push({ numBusca: 18, nombPregunta: 'SEDE A LA QUE PERTENECE:', respuesta: vecMatricula[0].matricula[0].nombSede });
        this.vecDataCalcula.push({ numBusca: 19, nombPregunta: 'COLEGIO DE GRADUACIÓN:', respuesta: vecColegio.carrera[0].strNombre });
        this.vecDataCalcula.push({ numBusca: 20, nombPregunta: 'TITULO:', respuesta: vecColegio.carrera[0].nombTitulo });
        this.vecDataCalcula.push({ numBusca: 21, nombPregunta: 'AÑO DE GRADUACIÓN:', respuesta: vecColegio.carrera[0].dtFecha.split('T')[0] });
        this.vecDataCalcula.push({ numBusca: 22, nombPregunta: 'TIPO COLEGIO:', respuesta: vecColegio.carrera[0].strDescripcion });
        this.vecDataCalcula.push({ numBusca: 23, nombPregunta: 'PREGUNTA:', respuesta: '' });
        this.vecDataCalcula.push({ numBusca: 24, nombPregunta: 'PREGUNTA:', respuesta: '' });
        this.vecDataCalcula.push({ numBusca: 25, nombPregunta: 'PREGUNTA:', respuesta: '' });
        this.vecDataCalcula.push({ numBusca: 26, nombPregunta: 'ETNIA CON LA QUE SE IDENTIFICA:', respuesta: vecCentral.listado[0].etn_nombre });
        this.vecDataCalcula.push({ numBusca: 27, nombPregunta: 'MANTIENE MATRICULA:', respuesta: vecMatricula[0].matriculaActual[0].etiqueta });
        this.vecDataCalcula.push({ numBusca: 28, nombPregunta: 'PROCEDENCIA', respuesta: vecCentral.listado[0].datosprocedencia });
        await this.obtenerPreguntasCuestionario(this.vecPeriodo[0].periodo[0].strCodigo);
      }
      else
        this.ruta.navigate(["/becario"]);
    }
    else
      this.ruta.navigate(["/becario"]);
    this.cargando.cerrar();
  }

  async obtenerPreguntasCuestionario(perActual) {
    //OBTENER EL CUESTIONARIO DADO EL ID DE RESPUESTA
    const resResCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(10, localStorage.getItem('lclResFicha'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    if (resResCuest.resultado) {
      if ((resResCuest.fichaEstudiantil[0].strPeriodo != perActual) || resResCuest.fichaEstudiantil[0].intEstado == 1)
        this.editaRes = true;
      //VER LA INFORMACIÓN DE UN CUESTIONARIO DADO SU ID
      const resCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(2, resResCuest.fichaEstudiantil[0].intEncuesta, 'na', 'na', 'na')
        .subscribe(translated => { resolve(translated) }));
      this.vecVerEncuesta = resCuest.resultado ? resCuest.fichaEstudiantil : [];
      //VER LOS GRUPOS DE PREGUNTAS RESGISTRADOS PARA UN CUESTIONARIO
      const resGrupo = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(5, resResCuest.fichaEstudiantil[0].intEncuesta, 'na', 'na', 'na')
        .subscribe(translated => { resolve(translated) }));
      this.vecVerGrupos = resGrupo.resultado ? resGrupo.fichaEstudiantil : [];
      //OBTENER LAS PREGUNTAS DEL CUESTIONARIO
      const resPreg = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(13, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerPreguntas = resPreg.resultado ? resPreg.fichaEstudiantil : [];
      //SI EL CUESTIONARIO ES VIGENTE Y NO FINALIZADO ANALIZAMOS LAS PREGUNTAS CALCULADAS
      if ((resResCuest.fichaEstudiantil[0].strPeriodo == perActual) && (resResCuest.fichaEstudiantil[0].intEstado != 1))
        this.registraCalculada();
      //VER LAS OPCIONES DE RESPUESTA REGISTRADAS PARA UN CUESTIONARIO
      this.datoEnc = resResCuest.fichaEstudiantil[0].intEncuesta; this.datoRes = resResCuest.fichaEstudiantil[0].strIdResponde;
      const resOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(12, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerOpciones = resOpc.resultado ? resOpc.fichaEstudiantil : [];
      //VER LAS SUB OPCIONES DE RESPUESTA REGISTRADAS PARA UN CUESTIONARIO
      const resSubOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(14, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerSubOpcion = resSubOpc.resultado ? resSubOpc.fichaEstudiantil : [];
    }
    else
      this.ruta.navigate(["/becario"]);
  }
  //REGISTRO DE PREGUNTAS CALCULADAS
  async registraCalculada() {
    let auxCalcula = []; let auxAddCalcula = []; let contPreg = 0;
    while (contPreg < this.vecVerPreguntas.length) {
      auxCalcula = this.vecDataCalcula.filter(objCal => objCal.numBusca == this.vecVerPreguntas[contPreg].pregBusca);
      if (auxCalcula.length > 0) {
        this.vecVerPreguntas[contPreg].resPregunta = auxCalcula[0].respuesta;
        auxAddCalcula.push(this.vecVerPreguntas[contPreg]);
      }
      contPreg++;
    }
    this.gestionRegistroFicha(9, auxAddCalcula, localStorage.getItem('lclResFicha'), 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na');
  }
  //VER LA SELECCION EN UN CHECKBOX
  marcaOpcionCheck(datoPreg, datoOp, evento) {
    let idRespuesta = localStorage.getItem('lclResFicha') + '_' + datoOp.pregId + '_' + datoOp.opcId;

    this.gestionRegistroFicha(7, idRespuesta, datoOp.gruId, datoOp.pregId, datoOp.opcId, datoPreg.pregNum, datoPreg.pregBusca, evento.target.checked, 0, '',
      localStorage.getItem('lclResFicha'), 1, 'na', 'na', 'na', 1);
  }
  //VER LA SELECCION EN UN RADIO BUTTON
  marcaOpcionRadio(datoPreg, datoOp) {
    let idRespuesta = localStorage.getItem('lclResFicha') + '_' + datoOp.pregId;

    this.gestionRegistroFicha(7, idRespuesta, datoOp.gruId, datoOp.pregId, datoOp.opcId, datoPreg.pregNum, datoPreg.pregBusca, 'true', 0, '',
      localStorage.getItem('lclResFicha'), 1, 'na', 'na', 'na', 1);
  }
  //REGISTRO DE UNA RESPUESTA TIPO TEXTO O NÚMERO
  registroRespuesta(datoPreg) {
    let idRespuesta = localStorage.getItem('lclResFicha') + '_' + datoPreg.pregId;
    this.gestionRegistroFicha(7, idRespuesta, datoPreg.gruId, datoPreg.pregId, 0, datoPreg.pregNum, datoPreg.pregBusca, datoPreg.resPregunta, 0, '',
      localStorage.getItem('lclResFicha'), 1, 'na', 'na', 'na', 0);
  }
  //REGISTRO DE UNA SUBOPCION
  registroResSubOpcion(datoSubOpc, op) {
    this.gestionRegistroFicha(8, localStorage.getItem('lclResFicha'), datoSubOpc.pregId, datoSubOpc.opcId, datoSubOpc.subOpId, op == 2 ? 'true' : datoSubOpc.resSubOpcion, 'na', 'na', 'na', 'na',
      'na', 'na', 'na', 'na', 'na', 0);
  }
  //GESTION PARA EL REGISTRO 
  async gestionRegistroFicha(opc, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15) {
    this.srvInsert.registroGestionFicha(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, opc)
      .subscribe(res => {
        if (res.respFicha) {
          this.alerti.message('Datos registrados correctamente');

          if (this.vecVerSubOpcion.findIndex(objOp => objOp.pregId == param3) >= 0)
            this.obtenerOpciones(this.datoEnc, this.datoRes)
        }
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
  }
  //OBTENER LAS OPCIONES MARCADAS
  async obtenerOpciones(encuesta, responde) {
    const resOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(12, encuesta, responde, 'na', 'na').subscribe(translated => { resolve(translated) }));
    this.vecVerOpciones = resOpc.resultado ? resOpc.fichaEstudiantil : [];
  }
  //ENVIO DE REGISTRO DEFINITIVO DE LA FICHA
  async envioFicha() {
    //OBTENER LAS RESPUESTAS DESDE LA BASE DE UNA FICHA
    const resFicha = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(11, this.datoRes, 'na', 'na', 'na').subscribe(translated => { resolve(translated) }));
    this.vecVerRespuesta = resFicha.resultado ? resFicha.fichaEstudiantil : [];
    //OBTENER LAS OPCIONES DE RESPUESTA
    const resOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(12, this.datoEnc, this.datoRes, 'na', 'na').subscribe(translated => { resolve(translated) }));
    this.vecVerOpciones = resOpc.resultado ? resOpc.fichaEstudiantil : [];
    //OBTENER LAS PREGUNTAS
    const resPreg = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(13, this.datoEnc, this.datoRes, 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerPreguntas = resPreg.resultado ? resPreg.fichaEstudiantil : [];
    let contPreg = 0; let contRojo = 0; let contNegro = 0;
    let auxSubRes = []; let auxResp = []; let auxValida = [];
    while (contPreg < this.vecVerPreguntas.length) {

      if (this.vecVerPreguntas[contPreg].resPregunta == '') {
        this.vecVerPreguntas[contPreg].clasColor = 'tdTxtRojo'; contRojo++;
      }
      if (this.vecVerOpciones.filter(objOpc => objOpc.pregId == this.vecVerPreguntas[contPreg].pregId && objOpc.responde != 'false' && objOpc.responde != null && objOpc.responde != '').length > 0) {
        this.vecVerPreguntas[contPreg].clasColor = 'tdTxtNegro'; contNegro++;
      }
      //VALIDAR SUBOPCIONES
      auxResp = this.vecVerRespuesta.filter(objRes => objRes.intPregunta == this.vecVerPreguntas[contPreg].pregId && objRes.intOpcion > 0)
      if (auxResp.length > 0) {
        auxSubRes = this.vecVerSubOpcion.filter(objSub => objSub.opcId == auxResp[0].intOpcion)
        if (auxSubRes.length > 0) {
          auxValida = this.vecVerRespuesta.filter(objRes => objRes.intPregunta == auxSubRes[0].pregId && objRes.strValorSubOpcion != '')
          if (auxValida.length < 1) {
            this.vecVerPreguntas[contPreg].clasColor = 'tdTxtRojo'; contRojo++;
          }
        }
      }
      contPreg++;
    }
    //VERIFICAR QUE TODOS LOS CAMPOS ESTEN LLENOS
    if ((contRojo - contNegro) == 0) {
      //CONFIRMACION DE ACTUALIZAR LA FICHA
      this.alerti.confirm('Al enviar a guardar la ficha usted ya no podrá realizar ningún cambio, desea continuar?', () => {
        this.cargando.abrir();
        this.srvInsert.registroGestionFicha(localStorage.getItem('lclResFicha'), 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 10)
          .subscribe(res => {
            if (res.respFicha) {

              this.alerti.message('Ficha registrada Correctamente');
              this.editaRes = true;
              this.enviarCorreo();
            }
            else
              this.alerti.error('Error inesperado vuelva a intentar más tarde');
          });
      });
    }
    else
      this.alerti.error('Debe responder todas las preguntas');
    this.cargando.cerrar();
  }
  async enviarCorreo() {
    let contenido = this.confMensaje.bodyMensaje(1, 'na', 'na', 'na', 'na', 'na') + localStorage.getItem('localNombre') + ' ' + localStorage.getItem('localApellidos') +
      this.confMensaje.bodyMensaje(10, 'na', 'na', 'na', 'na', 'na');
    this.srvInsert.envioMail('Ficha del estudiante: ' + this.vecDataCalcula[0].respuesta, this.vecDataCalcula[11].respuesta, btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
      else
        this.alerti.success('Ficha registrada con éxito');
      this.cargando.cerrar();
    });
  }
}
